import { StanButton } from '@/components';

import AllSetImage from '@/assets/images/automations/hero-autoreply-success.svg';

interface AllSetStateProps {
    onAcknowledge: () => void;
}

/**
 * Success state shown after connecting Instagram for the first time
 * Displays "You're All Set!" message with "Let's Go" button
 * Vue implementation: vue/src/pages/automations/Automations.vue (connect-success section)
 */
export const AllSetState = ({ onAcknowledge }: AllSetStateProps) => {
    return (
        <div className='flex h-full w-full justify-center'>
            <div className='mt-12 flex w-full max-w-80 flex-col items-center gap-6'>
                <div className='mx-7 mb-2 flex justify-center md:mx-0 md:mb-0'>
                    <AllSetImage className='h-auto w-full max-w-72 md:max-w-none' />
                </div>
                <div className='text-heading-h2 text-dark text-center leading-tight font-extrabold tracking-tight'>
                    You&apos;re All Set!
                </div>
                <div className='text-body-md text-gray md:text-body-lg text-center'>
                    Let&apos;s get started creating auto-replies to your customers on IG!
                </div>
                <div className='mt-6 w-full md:mt-0'>
                    <StanButton
                        name='automations-onboarding-success-button'
                        onClick={onAcknowledge}
                        className='w-full'
                        size='lg'
                    >
                        Let&apos;s Go
                    </StanButton>
                </div>
            </div>
        </div>
    );
};
